// src/components/SearchFilter.jsx

import React from "react";
import { FaSearch, FaFilter } from "react-icons/fa";
import { motion } from "framer-motion";

const SearchFilter = ({
  searchQuery,
  handleSearchChange,
  selectedLanguage,
  handleLanguageChange,
  availableLanguages,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="mb-8"
    >
      <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-xl p-6 shadow-xl">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Search Input */}
          <div className="flex-1 relative">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search projects..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300"
              aria-label="Search projects"
            />
          </div>

          {/* Language Filter */}
          <div className="relative md:w-64">
            <FaFilter className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <select
              value={selectedLanguage}
              onChange={handleLanguageChange}
              className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white focus:outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300 appearance-none cursor-pointer"
              aria-label="Filter by language"
            >
              <option value="" className="bg-gray-800">
                All Languages
              </option>
              {availableLanguages.map((language) => (
                <option key={language} value={language} className="bg-gray-800">
                  {language}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
              <svg
                className="w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Active filters indicator */}
        {(searchQuery || selectedLanguage) && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            className="mt-4 flex items-center gap-2 text-sm"
          >
            <span className="text-gray-400">Active filters:</span>
            {searchQuery && (
              <span className="bg-blue-500/20 text-blue-400 px-3 py-1 rounded-full">
                Search: "{searchQuery}"
              </span>
            )}
            {selectedLanguage && (
              <span className="bg-purple-500/20 text-purple-400 px-3 py-1 rounded-full">
                Language: {selectedLanguage}
              </span>
            )}
          </motion.div>
        )}
      </div>
    </motion.div>
  );
};

export default SearchFilter;
